import Col from 'react-bootstrap/Col'
import {Card, ListGroup, ListGroupItem} from 'react-bootstrap'
import {useContext, useEffect, useState} from 'react'
import Button from 'react-bootstrap/Button'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {CartContext} from '../../../contexts/CartContext'
import Numbers from '../../../helpers/Numbers'
import Select from '../../ui/form/Select'
import ModalCart from '../cart/ModalCart'

type ShopItemProps = {
    shopItem: object;
}

export const ShopItem = ({shopItem}: ShopItemProps) => {
    const itemUnitPrice = shopItem.articleTypes[0].articlesExtranetTypePrix;
    const [declination, setDeclination] = useState<string>(shopItem.articleTypes[0].articlesExtranetTypeLibelle)
    const [declinationId, setDeclinationId] = useState<number|undefined>(shopItem.articleTypes[0].articlesExtranetTypeId);
    const [quantity, setQuantity] = useState<number>(0);
    const {removeFromCart, addToCart, cartItems} = useContext(CartContext);
    const [isRemovable, setIsRemovable] = useState<boolean>(false);
    const [modalCartShow, setModalCartShow] = useState<boolean>(false);
    const [unitPrice, setUnitPrice] = useState<number>(shopItem.articleTypes[0].articlesExtranetTypePrix);

    // Permet de synchroniser les quantités du panier avec les articles
    useEffect(() => {
        if (cartItems.length > 0) {
            const itemIndex = cartItems.findIndex((item) => item.idSarticles === shopItem.idSarticles && item.cartSize === declination);

            if (itemIndex >= 0) {
                const itemTypeIndex = cartItems[itemIndex].articleTypes.findIndex((item) => item.articlesExtranetTypeId === cartItems[itemIndex].cartSizeId);

                if (itemTypeIndex >= 0) {
                    setQuantity(cartItems[itemIndex].cartQuantity);
                    setDeclination(cartItems[itemIndex].cartSize);
                    setDeclinationId(cartItems[itemIndex].cartSizeId);
                    setUnitPrice(cartItems[itemIndex].cartPriceUnit);
                    setIsRemovable(true);
                }
            }
        }
    }, [cartItems]);

    function getPrice(): string {
        let result = 'NC';

        if (itemUnitPrice) {
            if (itemUnitPrice > 0) {
                result = Numbers.ConvertToEuro(Number(itemUnitPrice))
            } else if (itemUnitPrice === '0') {
                result = 'GRATUIT'
            } else {
                result = Numbers.ConvertToEuro(Number(itemUnitPrice))
            }
        }

        return result;
    }

    function handleAddToCart(): void {
        if (isRemovable && quantity === 0) {
            removeFromCart(shopItem, declinationId);
            setIsRemovable(false);
        } else {
            addToCart(shopItem, quantity + 1, declination, declinationId, unitPrice);
            setIsRemovable(true);
        }

        setModalCartShow(true);
    }

    function handleDeclination(event) {
        const {value} = event.target;
        setDeclination(value);

        for (const articleType of shopItem.articleTypes) {
            if (articleType.articlesExtranetTypeLibelle === value) {
                setDeclinationId(articleType.articlesExtranetTypeId);
                setUnitPrice(articleType.articlesExtranetTypePrix);
                break;
            }
        }

        if (cartItems.length >= 0) {
            const itemIndex = cartItems.findIndex((item) => item.idSarticles === shopItem.idSarticles && item.cartSize === value);

            if (itemIndex > 0) {
                setQuantity(cartItems[itemIndex].cartQuantity);
                setIsRemovable(true);
            } else {
                setQuantity(0);
                setIsRemovable(false);
            }
        }
    }

    return (
        <Col xs={12} md={3} className={'mb-4'}>
            <Card className={'h-100 achats-item'}>
                <Card.Img
                    variant={'top'}
                    height={'368'}
                    src={`https://v3.monflorajet.com/ftp-extranet/OrderShop/Product/${shopItem.idSarticles}/01.jpg`}
                />
                <Card.Body>
                    <Card.Title className={'ucfirst'}>
                        {shopItem.articlesExtranetLibelle}
                    </Card.Title>
                    <Card.Text style={{whiteSpace: 'pre-wrap'}}>
                        {shopItem.articlesExtranetDescription}
                    </Card.Text>
                </Card.Body>

                {declination && shopItem.articleTypes?.length > 1 && (
                    <ListGroup
                        className={'list-group-flush align-items-center'}>
                        <ListGroupItem>
                            <Select
                                controlId={'sizeSelect'}
                                value={declination}
                                onChange={handleDeclination}
                                options={shopItem.articleTypes.map(
                                    (itemType) => (
                                        <option
                                            key={
                                                itemType.articlesExtranetTypeId
                                            }>
                                            {`${itemType.articlesExtranetTypeLibelle
                                                .charAt(0)
                                                .toUpperCase()}${itemType.articlesExtranetTypeLibelle
                                                .slice(1)
                                                .toLowerCase()}`}
                                        </option>
                                    ),
                                )}
                            />
                        </ListGroupItem>
                    </ListGroup>
                )}

                <Card.Footer className={'d-flex align-items-center'}>
                    <Col xs={4} className={'text-center px-0'}>
                        <span className={'price'}>{getPrice()}</span>
                        <br />
                        <small className={'text-secondary'}>
                            <i>(prix unitaire)</i>
                        </small>
                    </Col>
                    <Col xs={8}>
                        <Button
                            className={'btn-rounded mt-2 btn-block'}
                            disabled={quantity >= shopItem.articlesExtranetMaxi}
                            onClick={handleAddToCart}>
                            <FontAwesomeIcon
                                icon={'shopping-cart'}
                                color={'white'}
                                className={'mr-2'}
                            />
                            Ajouter au panier
                        </Button>
                        Max : {shopItem.articlesExtranetMaxi}{' '}
                    </Col>
                </Card.Footer>
            </Card>
            <ModalCart
                modalCartShow={modalCartShow}
                setModalCartShow={setModalCartShow}
            />
        </Col>
    )
}
